import { Attachment } from '../types/shared';

export const b64toBlob = (
    base64Data: string,
    contentType = 'application/octet-stream'
) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const fileToBase64 = async (
    file: File
): Promise<Attachment | undefined> => {
    if (!file) return;
    const reader = new FileReader();
    return await new Promise((res) => {
        reader.onload = (event) => {
            const match = file.name.match(/\.(\w+)$/);
            res({
                name: file.name,
                base64: event?.target?.result?.toString(),
                extension: match ? match[0] : '',
            });
        };

        reader.readAsDataURL(file);
    });
};

export function downloadFile(url: string, filename: string) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
